export enum DateLevelEnum {
  YEAR,
  MONTH,
  DAY
}
